// extracted by mini-css-extract-plugin
export default {"resources-section":"style_resources-section__zEpwr","grid":"style_grid__Hi2PD","resources-container":"style_resources-container__J0qRw"};